export default "__VITE_ASSET__PdB6uZmD__"